<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container"
  >
    <header-area />
    <div class="works" :class="readyAction ? 'ready-action' : ''">
      <div class="contentsBox contsBox">
        <div class="commonArea">
          <div class="defaultSect2">
            <div class="divInner">
              <div class="">
                <div class="web">
                  <div class="workTopText">
                    <span>We improve your</span>
                    <span>business with superior</span>
                    <span>creative</span>
                    <span>and technology.</span>
                  </div>
                </div>
                <div class="mobile">
                  <div class="workTopText">
                    <span>We improve</span>
                    <span>your</span>
                    <span>business with</span>
                    <span>superior creative and</span>
                    <span>technology.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="photoList">
            <ul>
              <li
                class="step"
                :class="itm.projectClass"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                v-for="(itm, idx) in topList"
                :key="idx"
              >
                <template v-if="idx % 2 === 0">
                  <router-link :to="{ name: itm.link }">
                    <div class="fl textInfo">
                      <span class="projectName">{{ itm.title }}</span>
                      <strong v-html="itm.content" />
                      <span class="arrowGo">
                        <img src="@/assets/images/@arrow_right.svg" alt="" />
                      </span>
                    </div>
                    <div class="fr photoInfo">
                      <div class="photoInfo_in">
                        <img :src="imglink(itm.thumb)" alt="" />
                      </div>
                    </div>
                  </router-link>
                </template>
                <template v-else>
                  <router-link :to="{ name: itm.link }">
                    <div class="fl photoInfo">
                      <div class="photoInfo_in">
                        <img :src="imglink(itm.thumb)" alt="" />
                      </div>
                    </div>
                    <div class="fr textInfo">
                      <span class="projectName">{{ itm.title }}</span>
                      <strong v-html="itm.content" />
                      <span class="arrowGo">
                        <img src="@/assets/images/@arrow_right.svg" alt="" />
                      </span>
                    </div>
                  </router-link>
                </template>
              </li>
            </ul>
            <div class="centerBar" />
          </div>

          <div class="defaultSect2 textMore">
            <a
              v-if="topLimit < workData.length"
              href="javascript:;"
              class="textMoreBtn"
              @click.prevent="toptMore"
              >more.more.more.</a
            >
          </div>

          <div class="defaultSect2">
            <div class="divInner">
              <div class="listConArea2">
                <transition-group name="fade">
                  <div v-for="(list, idx) in workList" :key="idx" class="worksList">
                    <p class="workYear">{{ list.years }}</p>
                    <ul>
                      <li v-for="(itm, i) in list.list" :key="'sub' + i">
                        <span>{{ $t(itm.name) }}</span>
                        <span>{{ $t(itm.type) }}</span>
                        <span>{{ $t(itm.build) }}</span>
                      </li>
                    </ul>
                  </div>
                </transition-group>
                <div class="workMore">
                  <a
                    v-if="workLimit < work.list.length"
                    href="javascript:;"
                    class="logoMore"
                    @click.prevent="workMore"
                  >
                    <img src="@/assets/images/@ico_more.svg" alt="" />
                    <span>more</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <router-link :to="{ name: 'contact' }" class="longEnd">
        <div class="endDefault">
          <span>Contact</span>
        </div>

        <div class="endTextArea">
          <div class="endText web">
            우리와 함께하고 싶다면 망설이지 마세요.<br />우리는 항상 당신을 기다리고 있어요.
          </div>
          <div class="endText mobile">
            우리와 함께하고 싶다면<br />망설이지 마세요.<br />우리는 항상 당신을<br />기다리고
            있어요.
          </div>
        </div>

        <div class="engBg workEndBg">
          <span />
        </div>
      </router-link>
    </div>
    <footer-area />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import work from "@/assets/json/work.json";
import common from "@/shared/mixin/common.js";
export default {
  mixins: [common],
  name: "Main",
  head: {
    title: function() {
      inner: this.meta.title;
    },
    meta: function() {
      return [
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName },
        { property: "og:description", content: this.meta.desc }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea
  },
  data() {
    return {
      work,
      topLimit: 3,
      workLimit: 2,
      readyAction: false,
      meta: {
        title: "프로젝트",
        siteName: "프로젝트 | 플립커뮤니케이션즈",
        desc:
          "Together, we rise above and beyond. 우리는 사람과 IT가 더욱 가까워질 수 있도록 서로를 이어주는 연결고리가 되길 원합니다. 그렇기에 디지털 세상에 일상을 보다 멋지고 조화롭게 담아내고, 모두가 이용하기 편리하게 만들어 가는 데 집중합니다.",
        keywords:
          "웹에이전시, 디지털에이전시, 디자인에이전시, UIUX에이전시, 디자인회사, 금융권전문웹에이전시, 기업홈페이지제작업체, 기업웹사이트제작업체, 쇼핑몰제작업체, 반응형홈페이지제작업체, 모바일웹개발업체, 모바일앱개발업체, UIUX, 온라인마케팅, 온라인프로모션, 웹기획, 웹디자인, 웹개발, 웹퍼블리싱, 앱기획, 앱디자인, 앱개발, 앱퍼블리싱, 디자인가이드, 디자인시스템, 기업아이덴티티",
        url: "https://www.pulip.com/works",
        img: "https://www.pulip.com/pulip-logo.jpg"
      }
    };
  },
  computed: {
    ...mapState("common", {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    topList() {
      return this.work.data.slice(0, this.topLimit);
    },
    workList() {
      return this.work.list.slice(0, this.workLimit);
    },
    workData() {
      return this.work.data;
    }
  },
  methods: {
    workMore() {
      this.workLimit += 1;
    },
    toptMore() {
      this.topLimit += 3;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.readyAction = true;
  }
};
</script>
